import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function QuizReady2() {
  const location = useLocation();
  const navigate = useNavigate();
  // const { quiz_id } = useParams(); // 👈 get quiz_id from URL
  const { startTime, quiz_id, quizType,theme_group_id } = location.state || {};
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    if (!startTime) return;

    const quizStartTime = new Date(startTime).getTime();

    const updateCountdown = () => {
      const now = Date.now();
      const diff = Math.max(quizStartTime - now, 0);
      setTimeLeft(diff);

      if (diff <= 0) {
        clearInterval(timer);
        navigate(`/quiz-dashboard/startQuiz/${quiz_id}`, {
          state: { quizType: quizType, quiz_id: Number(quiz_id) , theme_group_id:theme_group_id },
        }); // 👈 redirect to quiz
      }
    };

    updateCountdown(); // Run once immediately
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
  }, [startTime, navigate, quiz_id]);

  const minutes = Math.floor(timeLeft / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  return (
    <div>
      {startTime && quiz_id && (
        <div
          className="container text-center"
          style={{ color: "black", paddingTop: "20%" }}
        >
          <h2>Your Quiz will start in:</h2>
          <h1 style={{ fontSize: "2rem", marginTop: "40px" }}>
            {minutes}m {seconds}s
          </h1>
        </div>
      )}
    </div>
  );
}
